import axios from "axios";
const REACT_APP_ADMIN_API = process.env.REACT_APP_ADMIN_API;

export const getFullTemplates = async (query, page = 1, cancelToken) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_ADMIN_API}/api/fulltemplate?db=${region}&q=${query}&results_per_page=200`,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const getFullTemplate = async (name) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_ADMIN_API}/api/fulltemplate/${name}?db=${region}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      data: response.data,
    };
  } catch (e) {
    return { e };
  }
};

export const createFullTemplate = async (
  name,
  description,
  templateName,
  transformationName,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_ADMIN_API}/api/fulltemplate?db=${region}`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        name,
        description,
        template_name: templateName,
        transformation_name: transformationName,
      },
    });
    return {
      data: response.data,
    };
  } catch (e) {
    return { e };
  }
};

export const editFullTemplate = async (
  name,
  description,
  templateName,
  transformationName,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "put",
      url: `${REACT_APP_ADMIN_API}/api/fulltemplate/${name}?db=${region}`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        description,
        template_name: templateName,
        transformation_name: transformationName,
      },
    });
    return {
      data: response.data,
    };
  } catch (e) {
    return { e };
  }
};

export const deleteFullTemplate = async (name) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
    const response = await axios({
      method: "delete",
      url: `${REACT_APP_ADMIN_API}/api/fulltemplate/${name}?db=${region}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      data: response.data,
    };
};
